var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpin1S200Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(64,50)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.99s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.99s"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.972374197995805,50.879067273410385)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(3.6000000000000005)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.99
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.98s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.98s"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.88960581840269,51.75466526990026)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(7.200000000000001)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.98
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.97s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.97s"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.752021510201644,52.62333840420015)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(10.8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.97
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.96s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.96s"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.560164255800835,53.481658420307966)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(14.400000000000002)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.96
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.95s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.95s"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.31479122813215,54.326237921249266)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(18)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.95
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.94s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.94s"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.01687080243552,55.15374373758549)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(21.6)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.94
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.93s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.93s"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.66757873452427,55.96091008191102)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(25.200000000000003)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.93
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.92s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.92s"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.268293520614094,56.744551437424015)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(28.800000000000004)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.92
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.91s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.91s"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.82059095702821,57.501575129705955)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(32.400000000000006)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.91
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.9s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.9s"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.326237921249266,58.22899353209462)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(36)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.9
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.89s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.89s"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.78718539886105,58.923935856481656)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(39.599999999999994)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.89
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.88s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.88s"
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.20556078389976,59.58365948300164)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(43.2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.88
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.87s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.87s"
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.58365948300164,60.20556078389976)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(46.800000000000004)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.87
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.86s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.86s"
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.923935856481656,60.78718539886105)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(50.400000000000006)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.86
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.85s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.85s"
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.22899353209463,61.32623792124926)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(54)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.85
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.84s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.84s"
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.501575129705955,61.82059095702821)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(57.60000000000001)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.84
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.83s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.83s"
  }))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.744551437424015,62.268293520614094)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(61.20000000000001)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.83
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.82s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.82s"
  }))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.96091008191102,62.66757873452427)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(64.80000000000001)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.82
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.81s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.81s"
  }))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.15374373758549,63.01687080243552)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(68.39999999999999)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.81
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.8s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.8s"
  }))))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.326237921249266,63.31479122813215)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.8
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.79s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.79s"
  }))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.481658420307966,63.560164255800835)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(75.60000000000001)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.79
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.78s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.78s"
  }))))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.62333840420015,63.752021510201644)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(79.19999999999999)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.78
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.77s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.77s"
  }))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.754665269900265,63.889605818402686)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(82.8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.77
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.76s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.76s"
  }))))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.87906727341039,63.972374197995805)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(86.4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.76
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.75s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.75s"
  }))))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50,64)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.75
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.74s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.74s"
  }))))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.120932726589615,63.972374197995805)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(93.60000000000001)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.74
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.73s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.73s"
  }))))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.24533473009974,63.88960581840269)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(97.19999999999999)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.73
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.72s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.72s"
  }))))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.37666159579985,63.752021510201644)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(100.80000000000001)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.72
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.71s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.71s"
  }))))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.518341579692034,63.560164255800835)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(104.4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.71
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.7s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.7s"
  }))))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.67376207875074,63.31479122813215)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(108)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.7
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.69s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.69s"
  }))))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.846256262414514,63.01687080243552)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(111.6)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.69
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.68s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.68s"
  }))))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.03908991808898,62.66757873452427)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(115.20000000000002)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.68
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.67s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.67s"
  }))))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.255448562575985,62.26829352061409)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(118.80000000000003)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.67
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.66s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.66s"
  }))))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.498424870294045,61.82059095702821)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(122.40000000000002)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.66
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.65s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.65s"
  }))))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.77100646790538,61.326237921249266)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(126)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.65
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.64s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.64s"
  }))))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.076064143518344,60.78718539886105)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(129.60000000000002)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.64
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.63s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.63s"
  }))))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.41634051699836,60.205560783899756)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(133.20000000000002)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.63
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.62s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.62s"
  }))))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.794439216100244,59.58365948300164)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(136.79999999999998)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.62
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.61s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.61s"
  }))))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.21281460113895,58.923935856481656)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(140.4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.61
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.6s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.6s"
  }))))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.67376207875074,58.22899353209463)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.6
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.59s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.59s"
  }))))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.17940904297179,57.501575129705955)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(147.6)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.59
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.58s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.58s"
  }))))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.731706479385906,56.744551437424015)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(151.20000000000002)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.58
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.57s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.57s"
  }))))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.33242126547573,55.960910081911024)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(154.79999999999998)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.57
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.56s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.56s"
  }))))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.98312919756448,55.15374373758549)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(158.39999999999998)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.56
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.55s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.55s"
  }))))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.68520877186785,54.326237921249266)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(162)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.55
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.54s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.54s"
  }))))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.439835744199165,53.48165842030797)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(165.6)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.54
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.53s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.53s"
  }))))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.247978489798356,52.62333840420014)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(169.2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.53
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.52s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.52s"
  }))))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.110394181597314,51.754665269900265)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(172.8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.52
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.51s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.51s"
  }))))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.027625802004195,50.87906727341039)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(176.4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.51
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.5s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.5s"
  }))))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(36,50)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.5
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.49s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.49s"
  }))))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.027625802004195,49.120932726589615)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(183.6)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.49
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.48s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.48s"
  }))))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.11039418159731,48.24533473009974)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(187.20000000000002)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.48
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.47s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.47s"
  }))))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.247978489798356,47.37666159579985)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(190.8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.47
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.46s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.46s"
  }))))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.439835744199165,46.518341579692034)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(194.39999999999998)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.46
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.45s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.45s"
  }))))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.68520877186785,45.67376207875074)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(198.00000000000003)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.45
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.44s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.44s"
  }))))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.98312919756448,44.84625626241451)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(201.60000000000002)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.44
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.43s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.43s"
  }))))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.33242126547572,44.03908991808899)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(205.2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.43
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.42s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.42s"
  }))))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.73170647938591,43.255448562575985)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(208.8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.42
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.41s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.41s"
  }))))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.179409042971784,42.49842487029405)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(212.39999999999998)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.41
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.4s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.4s"
  }))))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.67376207875073,41.77100646790538)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(216)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.4
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.39s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.39s"
  }))))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.21281460113895,41.076064143518344)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(219.6)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.39
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.38s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.38s"
  }))))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.79443921610024,40.41634051699836)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(223.2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.38
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.37s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.37s"
  }))))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.41634051699836,39.79443921610024)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(226.8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.37
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.36s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.36s"
  }))))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.076064143518344,39.212814601138945)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(230.40000000000003)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.36
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.35s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.35s"
  }))))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.77100646790537,38.67376207875074)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(234)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.35
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.34s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.34s"
  }))))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.49842487029405,38.179409042971784)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(237.60000000000005)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.34
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.33s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.33s"
  }))))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.255448562575985,37.731706479385906)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(241.20000000000002)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.33
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.32s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.32s"
  }))))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.03908991808899,37.33242126547572)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(244.80000000000004)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.32
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.31s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.31s"
  }))))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.846256262414514,36.98312919756448)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(248.4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.31
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.3s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.3s"
  }))))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.673762078750734,36.68520877186785)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(252)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.29s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.29s"
  }))))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.518341579692034,36.439835744199165)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(255.60000000000002)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.29
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.28s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.28s"
  }))))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.37666159579985,36.247978489798356)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(259.20000000000005)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.28
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.27s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.27s"
  }))))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.245334730099735,36.110394181597314)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(262.8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.27
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.26s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.26s"
  }))))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.120932726589615,36.027625802004195)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(266.40000000000003)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.26
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.25s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.25s"
  }))))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50,36)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(270)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.25
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.24s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.24s"
  }))))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.87906727341038,36.027625802004195)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(273.59999999999997)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.24
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.23s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.23s"
  }))))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.75466526990026,36.11039418159731)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(277.2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.23
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.22s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.22s"
  }))))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.62333840420014,36.247978489798356)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(280.8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.22
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.21s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.21s"
  }))))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.481658420307966,36.439835744199165)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(284.40000000000003)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.21
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.2s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.2s"
  }))))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.32623792124926,36.68520877186785)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(288)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.2
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.19s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.19s"
  }))))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.153743737585486,36.98312919756448)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(291.59999999999997)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.19
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.18s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.18s"
  }))))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.960910081911,37.33242126547572)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(295.2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.18
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.17s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.17s"
  }))))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.74455143742402,37.73170647938591)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(298.80000000000007)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.17
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.16s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.16s"
  }))))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.501575129705955,38.17940904297179)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(302.40000000000003)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.16
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.15s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.15s"
  }))))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.22899353209462,38.673762078750734)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(306)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.15
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.14s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.14s"
  }))))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.92393585648165,39.212814601138945)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(309.59999999999997)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.14
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.13s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.13s"
  }))))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.58365948300163,39.79443921610023)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(313.19999999999993)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.13
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.12s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.12s"
  }))))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.205560783899756,40.41634051699835)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(316.79999999999995)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.12
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.11s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.11s"
  }))))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.787185398861055,41.076064143518344)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(320.40000000000003)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.11
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.1s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.1s"
  }))))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.32623792124926,41.77100646790537)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(324)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.1
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.09s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.09s"
  }))))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.82059095702821,42.49842487029404)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(327.59999999999997)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.09
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.08s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.08s"
  }))))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.26829352061408,43.25544856257598)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(331.2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.08
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.07s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.07s"
  }))))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.66757873452427,44.039089918088976)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(334.8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.07
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.06s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.06s"
  }))))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.01687080243552,44.846256262414514)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(338.4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.06
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.05s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.05s"
  }))))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.31479122813215,45.673762078750734)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(342)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.05
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.04s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.04s"
  }))))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.560164255800835,46.51834157969203)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(345.6)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.04
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.03s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.03s"
  }))))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.752021510201644,47.37666159579985)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(349.2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.03
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.02s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.02s"
  }))))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.889605818402686,48.245334730099735)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(352.8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.02
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.01s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.01s"
  }))))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.972374197995805,49.120932726589615)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(356.40000000000003)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#9747ff",
    fillOpacity: 0.01
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "0s",
    values: "1.22 1.22;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "0s"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpin1S200Px);
export default __webpack_public_path__ + "static/media/Spin-1s-200px.018e5c261c0e38b917dc5ee28d810c19.svg";
export { ForwardRef as ReactComponent };